<template>
  <div class="heading-chip" />
</template>

<script setup>
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

div {
    height: Pathfinder.$space-50;
    width: Pathfinder.$space-400;
    border-bottom-right-radius: Pathfinder.$space-100;
    background: var(--brand);
    margin-bottom: Pathfinder.$space-400;

    @include Pathfinder.below(min) {
        margin-bottom: Pathfinder.$space-300;
    }
}

</style>